import { z } from "zod";
import { email } from "~www/types/forms/schemas/email";
import { firstName } from "~www/types/forms/schemas/first-name";
import { lastName } from "~www/types/forms/schemas/last-name";
import { phone } from "~www/types/forms/schemas/phone";
import { postalCode } from "~www/types/forms/schemas/postal";

const careGiverLeadFormSchema = z.object({
  step1: z.object({
    Role: z.literal("caregiver"),
  }),
  step2: z.object({
    BusinessInEnglish: z.boolean().refine((val) => val === true, {
      error: "You must be able to conduct business in English",
    }),
    CanWorkInUS: z.boolean().refine((val) => val === true, {
      error: "You must be eligible to work in the US",
    }),
    Email: email,
    FirstName: firstName,
    jobID: z.string().refine((val) => val.length > 0 && val !== "0", {
      error: "You must select a job",
    }),
    LastName: lastName,
    OptInEmail: z.boolean().default(true),
    OptInSms: z.boolean().default(false),
    organizationNumber: z.number(),
    Phone: phone,
    // This is the postal code provided by the OfficeSelect component we send to our backend
    postalCode: z.string(),
    userEnteredLocation: postalCode,
  }),
});

export { careGiverLeadFormSchema };
